<script setup>
import localStorageKeys from '@/constants/local-storage-keys';
import routes from '@/constants/routes';

const { t } = useI18n();

const authStore = useAuthStore();

const isCookiesAccepted = useLocalStorage(
  localStorageKeys.COOKIES_ACCEPTED,
  false,
);

onMounted(() => {
  setTimeout(acceptCookies, 6000);
});

async function acceptCookies() {
  try {
    await gtagPushConsent('consent', 'update', {
      ad_storage: 'granted',
      analytics_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
      functionality_storage: 'granted',
      personalization_storage: 'granted',
    });

    await authStore.updateSessionInformation();
  } catch (error) {
    console.log(error);
  }

  isCookiesAccepted.value = true;
}
</script>

<template>
  <div class="bundles-cookies">
    <div class="bundles-cookies__text">
      <span class="bundles-cookies__font bundles-cookies__font--text">
        {{ t('cookies.text') }}

        <a class="bundles-cookies__link" :href="routes.PRIVACY" target="_blank">
          {{ t('cookies.link') }}
        </a>
      </span>
    </div>

    <button
      class="bundles-cookies__button"
      type="button"
      @click="acceptCookies"
    >
      <span class="bundles-cookies__font bundles-cookies__font--button">
        {{ t('cookies.button') }}
      </span>
    </button>
  </div>
</template>
